export default "__VITE_ASSET__CHzBRS8v__"